export const SOURCE_COLUMNS = [{
  header: "Ид",
  field: "source_id",
  bodyStyle: "text-align: right;",
},
{
  header: "Наименование",
  field: "source_name",
},
{
  header: "Наименование класса",
  field: "source_type_class",
},
{
  header: "Актуальность",
  field: "source_actual",
  dataType: "check-box",
  bodyStyle: "text-align: center",
  configComponent: {
    name: "i",
    classTrue: "pi true-icon pi-check",
    classFalse: "pi false-icon pi-times",
    componentFunction: () => { },
  },
},
{
  header: "Признак сохранения",
  field: "source_save_rate",
}
];

export const SOURCE_PARAM_COLUMNS = [
  {
    header: "Наимнование типа",
    field: "source_param_type_name"
  },
  {
    header: "Системное наименование типа",
    field: "source_param_type_sysname"
  },
  {
    header: "Значение",
    field: "source_param_value"
  }
];